import { default as indexvI2VGA9moVMeta } from "/usr/src/nuxt-app/pages/[financer]/[publicId]/index.vue?macro=true";
import { default as reviewV192O3HKicMeta } from "/usr/src/nuxt-app/pages/[financer]/[publicId]/review.vue?macro=true";
import { default as indexPBP6jHmdSQMeta } from "/usr/src/nuxt-app/pages/[financer]/index.vue?macro=true";
import { default as indexAT0xT66Xz7Meta } from "/usr/src/nuxt-app/pages/[financer]/limit/index.vue?macro=true";
import { default as _91prescoreId_93v7jucyvhp4Meta } from "/usr/src/nuxt-app/pages/[financer]/prescore/[prescoreId].vue?macro=true";
import { default as indexfpzo2QNfAsMeta } from "/usr/src/nuxt-app/pages/[financer]/prescore/index.vue?macro=true";
import { default as indexAoBMx6PnC1Meta } from "/usr/src/nuxt-app/pages/index.vue?macro=true";
import { default as _91campaignId_93ABP0sgd3ZFMeta } from "/usr/src/nuxt-app/pages/referral/[campaignId].vue?macro=true";
import { default as indexhQJgsRAftHMeta } from "/usr/src/nuxt-app/pages/referral/index.vue?macro=true";
import { default as _91campaignId_93BLwxkPspeBMeta } from "/usr/src/nuxt-app/pages/referrer/[campaignId].vue?macro=true";
export default [
  {
    name: indexvI2VGA9moVMeta?.name ?? "financer-publicId",
    path: indexvI2VGA9moVMeta?.path ?? "/:financer/:publicId",
    children: [],
    meta: indexvI2VGA9moVMeta || {},
    alias: indexvI2VGA9moVMeta?.alias || [],
    redirect: indexvI2VGA9moVMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/[financer]/[publicId]/index.vue").then(m => m.default || m)
  },
  {
    name: reviewV192O3HKicMeta?.name ?? "financer-publicId-review",
    path: reviewV192O3HKicMeta?.path ?? "/:financer/:publicId/review",
    children: [],
    meta: reviewV192O3HKicMeta || {},
    alias: reviewV192O3HKicMeta?.alias || [],
    redirect: reviewV192O3HKicMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/[financer]/[publicId]/review.vue").then(m => m.default || m)
  },
  {
    name: indexPBP6jHmdSQMeta?.name ?? "financer",
    path: indexPBP6jHmdSQMeta?.path ?? "/:financer",
    children: [],
    meta: indexPBP6jHmdSQMeta || {},
    alias: indexPBP6jHmdSQMeta?.alias || [],
    redirect: indexPBP6jHmdSQMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/[financer]/index.vue").then(m => m.default || m)
  },
  {
    name: indexAT0xT66Xz7Meta?.name ?? "financer-limit",
    path: indexAT0xT66Xz7Meta?.path ?? "/:financer/limit",
    children: [],
    meta: indexAT0xT66Xz7Meta || {},
    alias: indexAT0xT66Xz7Meta?.alias || [],
    redirect: indexAT0xT66Xz7Meta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/[financer]/limit/index.vue").then(m => m.default || m)
  },
  {
    name: _91prescoreId_93v7jucyvhp4Meta?.name ?? "financer-prescore-prescoreId",
    path: _91prescoreId_93v7jucyvhp4Meta?.path ?? "/:financer/prescore/:prescoreId",
    children: [],
    meta: _91prescoreId_93v7jucyvhp4Meta || {},
    alias: _91prescoreId_93v7jucyvhp4Meta?.alias || [],
    redirect: _91prescoreId_93v7jucyvhp4Meta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/[financer]/prescore/[prescoreId].vue").then(m => m.default || m)
  },
  {
    name: indexfpzo2QNfAsMeta?.name ?? "financer-prescore",
    path: indexfpzo2QNfAsMeta?.path ?? "/:financer/prescore",
    children: [],
    meta: indexfpzo2QNfAsMeta || {},
    alias: indexfpzo2QNfAsMeta?.alias || [],
    redirect: indexfpzo2QNfAsMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/[financer]/prescore/index.vue").then(m => m.default || m)
  },
  {
    name: indexAoBMx6PnC1Meta?.name ?? "index",
    path: indexAoBMx6PnC1Meta?.path ?? "/",
    children: [],
    meta: indexAoBMx6PnC1Meta || {},
    alias: indexAoBMx6PnC1Meta?.alias || [],
    redirect: indexAoBMx6PnC1Meta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91campaignId_93ABP0sgd3ZFMeta?.name ?? "referral-campaignId",
    path: _91campaignId_93ABP0sgd3ZFMeta?.path ?? "/referral/:campaignId",
    children: [],
    meta: _91campaignId_93ABP0sgd3ZFMeta || {},
    alias: _91campaignId_93ABP0sgd3ZFMeta?.alias || [],
    redirect: _91campaignId_93ABP0sgd3ZFMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/referral/[campaignId].vue").then(m => m.default || m)
  },
  {
    name: indexhQJgsRAftHMeta?.name ?? "referral",
    path: indexhQJgsRAftHMeta?.path ?? "/referral",
    children: [],
    meta: indexhQJgsRAftHMeta || {},
    alias: indexhQJgsRAftHMeta?.alias || [],
    redirect: indexhQJgsRAftHMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: _91campaignId_93BLwxkPspeBMeta?.name ?? "referrer-campaignId",
    path: _91campaignId_93BLwxkPspeBMeta?.path ?? "/referrer/:campaignId",
    children: [],
    meta: _91campaignId_93BLwxkPspeBMeta || {},
    alias: _91campaignId_93BLwxkPspeBMeta?.alias || [],
    redirect: _91campaignId_93BLwxkPspeBMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/referrer/[campaignId].vue").then(m => m.default || m)
  }
]